import React from "react";
import { Avatar, Box, Flex, HStack, Text, VStack, useBreakpointValue, useColorModeValue } from "@chakra-ui/react";
import { ColorModeSwitcher } from "../../ColorModeSwitcher";

// Responsive header height, shared with the page for top padding and sticky offsets
export const HEADER_HEIGHT = { base: "56px", md: "64px" };

interface CertificateHeaderProps {
  orgName: string;
  orgSubtitle?: string;
  orgLogoUrl?: string;
}

export const CertificateHeader: React.FC<CertificateHeaderProps> = ({
  orgName,
  orgSubtitle,
  orgLogoUrl,
}) => {
  const bg = useColorModeValue("white", "gray.800");
  const borderColor = useColorModeValue("gray.200", "gray.700");
  const subtitleColor = useColorModeValue("gray.500", "gray.400");
  const avatarSize = useBreakpointValue({ base: "xs", md: "sm" });

  return (
    <Box
      w="100%"
      bg={bg}
      borderBottomWidth={1}
      borderColor={borderColor}
      position="fixed"
      top="0"
      zIndex={100}
    >
      <Flex
        maxW="1200px"
        mx="auto"
        px={{ base: 4, md: 6 }}
        h={HEADER_HEIGHT}
        alignItems="center"
        justifyContent="space-between"
      >
        <HStack spacing={3} minW="0">
          <Avatar size={avatarSize} src={orgLogoUrl} name={orgName} />
          <VStack spacing={0} alignItems="flex-start" minW="0">
            <Text fontSize={{ base: "sm", md: "md" }} fontWeight="bold" lineHeight="short" isTruncated>
              {orgName}
            </Text>
            {orgSubtitle && (
              <Text fontSize="xs" color={subtitleColor} lineHeight="short" isTruncated>
                {orgSubtitle}
              </Text>
            )}
          </VStack>
        </HStack>
        <ColorModeSwitcher />
      </Flex>
    </Box>
  );
};
